import { render, staticRenderFns } from "./smsMessageDetailBox.vue?vue&type=template&id=77432f66"
import script from "./smsMessageDetailBox.vue?vue&type=script&lang=js"
export * from "./smsMessageDetailBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports